<template>
  <div>
    <MainNavigation page-name="My Class" :routeIndex="routeIndex"/>
    <NotificationBar msg-text="Edit your student list" />
    <Loader v-if="!currentClass" />
    <section v-if="currentClass">
      <div>
        <h2>Class Info</h2>
      </div>
      <div
        :class="
          'class-item static ' + $filters.colorAssign(currentClass.classId)
        "
      >
        <div>
          <h2 class="class-nickname">
            {{ currentClass.classInfo.nickname }}
          </h2>
          <p class="class-title">
            {{ currentClass.classInfo.subject }}
          </p>
          <ul id="example-1">
            <li
              v-for="(newDay, idx) in currentClass.classInfo.checkedDay"
              :key="idx"
            >
              {{ newDay
              }}{{
                idx == currentClass.classInfo.checkedDay.length - 1 ? "" : "|"
              }}
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div style="text-align: left">
        <h2>Edit Student List</h2>
        <p>
          Edit student names or nicknames, add new students, or archive their
          entries.
          <br />
          Students will see their nicknames instead of their full names in the
          app.
        </p>
      </div>
      <p
        v-if="validArray.filter((item) => item > 0).length != 0"
        style="
          display: flex;
          font-weight: bold;
          font-width: 16px;
          color: #eb5757;
        "
      >
        See errors below.
      </p>
      <div
        v-if="validArray.filter((item) => item > 0).length != 0"
        :class="{ error: validArray.filter((item) => item > 0).length != 0 }"
        style="padding: 1rem"
      >
        <p
          v-if="validArray.filter((item) => item >= 1).length != 0"
          style="display: flex; align-items: center"
        >
          <img
            src="@/assets/error_outline_24px.svg"
            style="padding-right: 0.5rem"
          />
          Student must have unique names. Please remove duplicate names.
        </p>
        <p
          v-if="validArray.filter((item) => item == 2).length != 0"
          style="display: flex; align-items: center"
        >
          <img
            src="@/assets/error_outline_24px.svg"
            style="padding-right: 0.5rem"
          />
          For students with identical names, add a unique nickname.
        </p>
      </div>
      <ul class="student-list">
        <li
          v-for="(student, index) in allStudents"
          :key="index"
          :class="{ error: validArray[index] != 0 }"
        >
          <!-- <p v-if="validArray[index] == 0">No Error</p>
        <p v-else-if="validArray[index] == 1">Error 1</p>
        <p v-else>Error 2</p> -->
          <div class="student-form">
            <h4>Student {{ index + 1 }}</h4>
            <div>
              <!-- <span
                class="material-icons-round button"
                @click="removeStudent(index)"
                >remove_circle</span
              > -->
              <span
                class="material-icons-round button"
                @click="archiveStudent(index)"
                >archive</span
              >
            </div>
          </div>
          <input
            type="text"
            placeholder="First Name & Last Initial"
            v-model="student.studentName"
          />
          <div v-if="student.isNickNameOpen">
            <div class="student-form">
              <h4>Nickname</h4>
              <span
                class="material-icons-round button"
                @click="closeNickname(student)"
                >remove_circle</span
              >
            </div>
            <div class="nickname-form">
              <input
                type="text"
                placeholder="Nickname"
                v-model="student.studentNickname"
              />
            </div>
          </div>
          <button
            style="margin: 1rem 0"
            class="add-nickname-button"
            v-if="!student.isNickNameOpen"
            @click="student.isNickNameOpen = true"
          >
            <span class="material-icons-round">add_circle</span>
            Add a Nickname
          </button>
        </li>
      </ul>

      <div class="add-student" style="margin-bottom: 2rem">
        <button @click="addAStudent()" class="add-student-button">
          <span class="material-icons-round">add_circle</span>
          <span>Add a Student</span>
        </button>
      </div>

      <button class="save-button" @click="checkIfValid()">Save</button>

      <Modal v-show="isModalVisible" @close="closeModal">
        <template v-slot:header> <b>Confirm Archiving</b> </template>
        <template v-slot:body>
          You are archiving
          <b>{{ studentToArchive ? studentToArchive.studentName : "" }}</b
          >. You will still be able to view their past report cards, but you
          <b>will not be able to restore them to your class list</b>.
        </template>

        <template v-slot:footer>
          <div class="modal-button-group">
            <button class="cancel-button" @click="closeModal">Cancel</button>
            <button @click="confirmArchiveStudent">Archive</button>
          </div>
        </template>
      </Modal>
    </section>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";
import Modal from "../components/Modal.vue";
import Loader from "../components/Loader.vue";
export default {
  name: "EditStudentList",
  components: {
    MainNavigation,
    NotificationBar,
    Modal,
    Loader,
  },
  props: ["name", "routeIndex"],
  data() {
    return {
      studentEntry: null,
      studentNumber: 0,
      showStudentList: true,
      studentToArchive: null,
      isModalVisible: false,
    };
  },
  computed: {
    classList() {
      return this.currentClass.studentList;
    },
    allClasses() {
      return this.$store.state.allClasses;
    },
    currentClass() {
      for (let i = 0; i < this.$store.state.allClasses.length; i++) {
        const thisClass = this.$store.state.allClasses[i];
        if (thisClass.classInfo.nickname == this.$route.params.name) {
          return this.$store.state.allClasses[i];
        }
      }
      return {
        classId: null,
        classInfo: {
          nickname: null,
          checkedDay: [],
          grade: null,
          subject: null,
        },
        studentList: [],
      };
    },
    allStudents() {
      return this.currentClass.studentList;
    },
    validArray() {
      let tempArray = [];
      for (let index = 0; index < this.classList.length; index++) {
        tempArray[index] = 0;
      }
      for (
        let firstIndex = 0;
        firstIndex < this.classList.length;
        firstIndex++
      ) {
        let firstStudent = this.classList[firstIndex];
        for (
          let secondIndex = 0;
          secondIndex < this.classList.length;
          secondIndex++
        ) {
          let secondStudent = this.classList[secondIndex];
          if (
            firstIndex != secondIndex &&
            firstStudent.studentName != "" &&
            secondStudent.studentName != "" &&
            firstStudent.studentName == secondStudent.studentName
          ) {
            if (
              firstStudent.studentNickname != "" &&
              secondStudent.studentNickname != "" &&
              firstStudent.studentNickname == secondStudent.studentNickname
            ) {
              // Duplicate Names / Duplicate Nicknames
              tempArray[firstIndex] = 2;
              tempArray[secondIndex] = 2;
            } else if (
              firstStudent.studentNickname != secondStudent.studentNickname
            ) {
              // Duplicate Names / Different Nicknames
              tempArray[firstIndex] = 0;
              tempArray[secondIndex] = 0;
            } else {
              // Duplicate Names / No Nicknames
              tempArray[firstIndex] = 1;
              tempArray[secondIndex] = 1;
            }
          }
        }
      }
      return tempArray;
    },
  },
  methods: {
    checkIfValid: function () {
      let flag = true;
      if (this.validArray.filter((item) => item > 0).length != 0) flag = false;
      if (this.classList.filter((item) => item.studentName == "") != 0)
        flag = false;
      if (this.classList.length == 0) flag = false;
      if (flag) this.saveClass();
    },
    saveClass: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          studentList: this.classList,
          classId: this.currentClass.classId,
        },
        opCode: this.$store.state.opCodes.UpdateClassStudentList,
      });
      this.$store.commit("SEND_MESSAGE", {
        data: this.currentClass.classId,
        opCode: this.$store.state.opCodes.PastSessionsCount,
      });
      this.$router.push({
        name: "class-info",
        params: { name: this.currentClass.classInfo.nickname },
      });
    },
    addAStudent() {
      this.studentNumber++;
      this.classList.push({
        isNickNameOpen: false,
        studentName: "",
        studentNickname: "",
      });
    },
    closeNickname(student) {
      student.isNickNameOpen = false;
      student.studentNickname = "";
    },

    archiveStudent(index) {
      if (this.classList[index].archived == true) {
        this.classList[index].archived = false;
      } else {
        this.studentToArchive = this.classList[index];
        this.showModal();
      }
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    confirmArchiveStudent() {
      this.classList[
        this.classList.indexOf(this.studentToArchive)
      ].archived = true;
      this.closeModal();
    },
    removeStudent(index) {
      this.classList.splice(index, 1);
      this.studentNumber--;
    },
  },
};
</script>

<style>
/* /* ../assets/scss/_student-list.scss */
</style>